import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import NoMatchQuery from 'Query/NoMatch.query';
import {
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps,
    NoMatchContainer as SourceNoMatchContainer
} from 'SourceRoute/NoMatch/NoMatch.container';
import { toggleBreadcrumbs } from 'Store/Breadcrumbs/Breadcrumbs.action';
import { fetchQuery } from 'Util/Request';

/** @namespace PeggysagePwa/Route/NoMatch/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state)
    // ...
});

/** @namespace PeggysagePwa/Route/NoMatch/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch),
    toggleBreadcrumbs: (isVisible) => dispatch(toggleBreadcrumbs(isVisible))
});

/** @namespace PeggysagePwa/Route/NoMatch/Container */
export class NoMatchContainer extends SourceNoMatchContainer {
    static propTypes = {
        ...SourceNoMatchContainer.propTypes,
        toggleBreadcrumbs: PropTypes.func.isRequired
    };

    state = {
        items: [],
        isLoading: false
    };

    __construct() {
        this._isMounted = false;
    }

    /**
     * Override: fetch push content
     */
    componentDidMount() {
        const { toggleBreadcrumbs } = this.props;

        this._isMounted = true;

        toggleBreadcrumbs(false);

        super.componentDidMount();

        this.fetchData();
    }

    /**
     * Override: set state to prevent memory leak
     */
    componentWillUnmount() {
        this._isMounted = false;

        super.componentWillUnmount();
    }

    /**
     * Override
     * @returns {{isLoading: boolean, items: *[]}}
     */
    containerProps() {
        const { items, isLoading } = this.state;

        return {
            ...super.containerProps(),
            items,
            isLoading
        };
    }

    async fetchData() {
        this.setState({ isLoading: true });

        fetchQuery(
            NoMatchQuery.getPushPage404()
        ).then(
            /** @namespace PeggysagePwa/Route/NoMatch/Container/NoMatchContainer/fetchData/fetchQuery/then */
            (res) => {
                if (this._isMounted) {
                    this.setState({
                        items: res.getPushPage404,
                        isLoading: false
                    });
                }
            }
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NoMatchContainer);
